module.exports = __webpack_public_path__ + "static/media/loc3_img34.8268803b.jpg";